import React from "react";
import { Navigate, useParams } from "react-router-dom";

const RedirectToPatientDashboard = () => {
    const { id } = useParams();
    return <Navigate to={`/mes-patients/${id}/dashboard`} replace />;
};

export default RedirectToPatientDashboard;
